import { useSite } from "@/lib/content";
import { t, setLang } from "@/lib/i18n";
import { Link } from "react-router-dom";
import { SectionHeader } from "@/pages/admin/ui";

const filled = (v) => typeof v === "string" && v.trim() !== "";

function collect(c) {
  setLang("tr");
  const rows = [];
  Object.entries(c.visit || {}).forEach(([k, f]) => rows.push({ id: `visit-${k}`, label: `Ziyaret · ${t(`ziyaret.fields.${k}`)}`, tr: filled(f.value), trOk: f.verified, en: filled(f.en?.value), enOk: f.en?.verified }));
  Object.entries(c.privacy || {}).forEach(([k, f]) => rows.push({ id: `privacy-${k}`, label: `Yasal · ${k === "text" ? "Gizlilik metni" : "Güncelleme tarihi"}`, tr: filled(f.value), trOk: f.verified, en: filled(f.en?.value), enOk: f.en?.verified }));
  (c.modules || []).forEach((m) => rows.push({ id: `module-${m.id}`, label: `Modül · ${m.title}`, tr: filled(m.body), trOk: m.visible && m.verified, en: filled(m.en?.body) && filled(m.en?.title), enOk: m.en?.verified }));
  (c.gallery || []).forEach((g, i) => rows.push({ id: `gallery-${g.id}`, label: `Galeri · ${i + 1}. görsel alt metni${g.stock ? " (temsili)" : ""}`, tr: filled(g.alt), trOk: !g.stock, en: filled(g.en?.alt), enOk: g.en?.verified }));
  ["hero", "wide"].forEach((k) => {
    const m = c.media?.[k];
    if (m) rows.push({ id: `media-${k}`, label: `Görsel · ${k === "hero" ? "Ana görsel" : "Geniş bölüm"} alt metni`, tr: filled(m.alt), trOk: !m.stock, en: filled(m.en?.alt), enOk: m.en?.verified });
  });
  return rows;
}

function state(r) {
  if (!r.en) return ["EN metin yok", "bg-stone-100 text-stone-600"];
  if (!r.enOk) return ["EN doğrulanmadı", "bg-[#FEF3C7] text-[#78350F]"];
  if (!(r.tr && r.trOk)) return ["EN hazır, TR canlı değil", "bg-stone-100 text-stone-600"];
  return ["EN canlıda görünür", "bg-[#ECFDF3] text-[#05603A]"];
}

export default function EnglishSection() {
  const { content, notices, enLive } = useSite();
  const rows = collect(content);
  (notices || []).forEach((n) => rows.push({ id: `notice-${n.notice_id}`, label: `Duyuru · ${n.title?.tr || "(başlıksız)"}`, tr: !!n.title?.tr, trOk: n.verified_tr, en: !!n.title?.en, enOk: n.verified_en }));
  const pending = rows.filter((r) => state(r)[0] !== "EN canlıda görünür");
  return (
    <section data-testid="admin-section-ingilizce">
      <SectionHeader title="İngilizce" text="İngilizce metinler yalnızca Türkçe karşılığı canlıdayken ve “EN Doğrulandı” işaretliyken İngilizce sitede görünür. Arayüz metinleri sabittir; buradaki liste içerik alanlarını gösterir." />
      <div className="flex flex-wrap items-center gap-3 mb-6">
        <span className={`rounded-full px-3 py-1 text-sm font-semibold ${enLive ? "bg-[#ECFDF3] text-[#05603A]" : "bg-stone-100 text-stone-700"}`} data-testid="english-live-state">
          İngilizce sürüm: {enLive ? "Yayında" : "Kapalı (Ayarlar’dan açılır)"}
        </span>
        <Link to="/en?gorunum=onizleme" className="inline-flex items-center min-h-[44px] px-5 rounded-full border border-line bg-white text-sm font-semibold hover:bg-cream" data-testid="english-preview-link">İngilizce önizlemeyi aç</Link>
      </div>
      <p className="text-sm text-ink-muted mb-3" data-testid="english-pending-count">Bekleyen İngilizce alan: {pending.length} / {rows.length}</p>
      <ul className="divide-y divide-line rounded-2xl border border-line bg-white">
        {rows.map((r) => {
          const [label, cls] = state(r);
          return (
            <li key={r.id} className="flex flex-wrap items-center justify-between gap-2 px-5 py-3" data-testid={`english-row-${r.id}`}>
              <span className="text-sm text-ink">{r.label}</span>
              <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`}>{label}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
